import ModelMappingValueOrigin from "~/models/mapping/modelMappingValueOrigin";
import ObjectModelProperty from "~/models/objectModelProperties/objectModelProperty";
import ModelMappingValueOriginObjectModelProperty from "~/models/mapping/modelMappingValueOriginObjectModelProperty";
import ObjectModelRelation from "~/models/objectModelRelations/objectModelRelation";
import ModelMappingValueOriginObjectModelRelation from "~/models/mapping/modelMappingValueOriginObjectModelRelation";
import ModelMappingOriginObjectModel from "~/models/mapping/modelMappingOriginObjectModel";
import ModelMappingOriginRelationIdentifier from "~/models/mapping/modelMappingOriginRelationIdentifier";

export default class ModelMappingValueOriginRelationIdentifier extends ModelMappingValueOrigin<ObjectModelProperty | ObjectModelRelation, ModelMappingOriginObjectModel | ModelMappingOriginRelationIdentifier> {
  get origin(): ObjectModelProperty | ObjectModelRelation {
    return this.subValueOrigin?.origin
  }

  get value() {
    return this.subValueOrigin?.value
  }

  get valueType(): string {
    return this.subValueOrigin?.valueType
  }

  get isIndexed(): boolean {
    return this.subValueOrigin?.isIndexed
  }

  get isUploader(): boolean {
    return this.subValueOrigin?.isUploader
  }

  get isRecordId(): boolean {
    return this.subValueOrigin?.isRecordId
  }

  get isBuiltIn(): boolean {
    return this.subValueOrigin?.isBuiltIn
  }

  get valueOriginObjectModelProperty() {
    return new ModelMappingValueOriginObjectModelProperty(this.id, this.modelMappingOrigin)
  }

  get valueOriginObjectModelRelation() {
    return new ModelMappingValueOriginObjectModelRelation(this.id, this.modelMappingOrigin)
  }

  get isSinglePicklist(): boolean {
    return this.subValueOrigin?.isSinglePicklist
  }

  get isMultiPicklist(): boolean {
    return this.subValueOrigin?.isMultiPicklist
  }

  get originType() {
    return this.subValueOrigin.originType
  }

  get categoryKey() {
    switch (this.mode) {
      case 'property':
        return 'ObjectModelProperties'
      case 'relation':
        return 'ObjectModelRelations'
    }
  }

  // Don't have a great way to determine which value origin to use
  // check to see if id goes to property or relation, then use the one that works
  private get subValueOrigin() {
    if (this.valueOriginObjectModelProperty.value) {
      return this.valueOriginObjectModelProperty
    } else if (this.valueOriginObjectModelRelation.value) {
      return this.valueOriginObjectModelRelation
    }
  }

  private get mode() {
    if (this.subValueOrigin instanceof ModelMappingValueOriginObjectModelProperty) {
      return 'property'
    } else if (this.subValueOrigin instanceof ModelMappingValueOriginObjectModelRelation) {
      return 'relation'
    }
  }
}